import React from 'react';
import styled from '@emotion/styled';
import { BlockEmbed } from 'data/SingleArticle/types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Callout } from 'components/Callout/Callout';
import { PullQuote } from 'components/PullQuote/PullQuote';
import { ImageBlock } from 'components/ImageBlock/ImageBlock';
import { WistiaVideo } from 'components/Video/WistiaVideo';
import { YoutubeVideo } from 'components/Video/YoutubeVideo';
import { ZapTemplate } from 'components/ZapTemplate/ZapTemplate';
import { Table } from 'components/Table/Table';
import { baseMarksElementsConfiguration, richImageBody } from './configuration';

const TemporalComponent = styled.div`
  background-color: red;
  color: white;
  font-weight: 600;
  font-size: 20px;
  text-align: center;
  padding: 40px;
`;

export function renderBlockEmbed(blockEmbed: BlockEmbed) {
  if (blockEmbed.__typename === 'ZapTemplateComponent') {
    const { zapTemplateIDs } = blockEmbed;

    if (!zapTemplateIDs || !zapTemplateIDs.length) {
      console.log('Bad ZapTemplateTopic');
      return <TemporalComponent>Bad ZapTemplateTopic</TemporalComponent>;
    }

    return (
      <ZapTemplate templateIds={zapTemplateIDs.filter(Boolean) as string[]} />
    );
  }

  if (blockEmbed.__typename === 'CalloutTopic') {
    const { body } = blockEmbed;

    if (!body) {
      throw new Error('Bad CalloutTopic');
    }

    return <Callout body={body} />;
  }

  if (blockEmbed.__typename === 'PullQuoteTopic') {
    const { quote, quoteByLine } = blockEmbed;

    if (!quote) {
      console.log('Bad PullQuoteTopic');

      return <TemporalComponent>Bad PullQuoteTopic</TemporalComponent>;
    }

    return <PullQuote quote={quote} quoteBy={quoteByLine} />;
  }

  if (blockEmbed.__typename === 'RichImageAsset') {
    const { image, describedImage, maxWidth, caption } = blockEmbed;
    const url = image?.url || '';
    const title = image?.title || '';
    const alt = describedImage || '';

    if (!image || !url) {
      console.log('Bad RichImageAsset');
      return <TemporalComponent>Bad RichImageAsset</TemporalComponent>;
    }

    const formattedCaption = documentToReactComponents(caption?.json, {
      renderNode: richImageBody,
      renderMark: baseMarksElementsConfiguration,
    });

    return (
      <ImageBlock image={{ maxWidth, alt, title, url }}>
        {formattedCaption}
      </ImageBlock>
    );
  }

  if (blockEmbed.__typename === 'VideoAsset') {
    const { videoId, videoProvider } = blockEmbed;

    if (
      !videoId ||
      (videoProvider?.name?.toLowerCase() !== 'wistia' &&
        videoProvider?.name?.toLowerCase() !== 'youtube')
    ) {
      console.log('Bad VideoID or VideoProvider');
      return <TemporalComponent>Bad VideoAsset</TemporalComponent>;
    }

    if (videoProvider?.name === 'Wistia') {
      return <WistiaVideo videoId={videoId} />;
    }

    return <YoutubeVideo videoId={videoId} />;
  }

  if (blockEmbed.__typename === 'Table') {
    const { table } = blockEmbed;

    if (!table) {
      console.log('Bad Table');
      return <TemporalComponent>Bad Table</TemporalComponent>;
    }

    return <Table data={table.tableData} />;
  }

  if (blockEmbed.__typename === 'SectionAnchorAssembly') {
    const { htmlId } = blockEmbed;

    if (!htmlId) {
      console.log('Bad SectionAnchorAssembly');
      return <TemporalComponent>Bad SectionAnchorAssembly</TemporalComponent>;
    }

    return <div id={htmlId} />;
  }

  /**
   * Render `null` if we don't find a matching component.
   */
  return null;
}
